<template>
  <div class="overflow-auto">
    <div v-if="data && data.length > 0">
      <b-card
        v-for="(item, index) in data"
        no-body
        class="px-3 py-1 mb-2 mt-3 block-list-history"
        :key="index"
      >
        <b-card-header header-tag="header" class="p-0" role="tab">
          <b-row
            v-b-toggle="'remittance_' + index"
            class="d-flex align-items-center"
          >
            <div class="px-3 d-flex align-items-center">
              <div class="fz-16 fw-700 d-flex flex-column">
                <span class="mr-3">{{ item.payeeAccountName }}</span>
                <div class="fz-14 fw-700 text-grey7">
                  {{ item.payeeUserNo }}
                </div>
              </div>
              <div
                :class="
                  'ml-3 badge-default text-nowrap badge-' +
                  item.status.toLowerCase()
                "
              >
                {{
                  $t(item.status.charAt(0).toUpperCase() + item.status.slice(1))
                }}
              </div>
            </div>
            <div class="px-3 ml-auto d-flex flex-column">
              <div class="fz-14 fw-700">
                {{ item.fundType == "in" ? "+" : "-" }} {{ item.paymentCcy }}
                {{ getPrice(parseFloat(item.payerAmt)) }}
              </div>
              <div class="fz-14 fw-400 text-grey7">
                {{ item.updated_at ? item.updated_at : item.created_at }}
              </div>
            </div>
            <div v-if="item.status.toLowerCase() == 'pending document'">
              <button
                class="btn btn-primary"
                @click="goToRemittanceSuportingDoc(item.orderId)"
              >
                {{ $t("Upload supporting document") }}
              </button>
            </div>
            <div v-if="item.status.toLowerCase() == 'approved'">
              <button class="btn btn-secondary" @click="viewDetails(item)">
                {{ $t("View Details") }}
              </button>
            </div>
          </b-row>
        </b-card-header>
        <b-collapse
          :id="'remittance_' + index"
          accordion="my-accordion"
          role="tabpanel"
          class="expand"
        >
          <b-card-body class="px-2 pt-0">
            <hr />
            <div class="d-flex mb-2">
              <div>Payment Methods</div>
              <div class="ml-auto fw-500">{{ item.paymentMode }}</div>
            </div>
            <div class="d-flex mb-2">
              <div>Amount</div>
              <div class="ml-auto fw-500">
                {{ item.paymentCcy }} {{ getPrice(parseFloat(item.payerAmt)) }}
              </div>
            </div>
            <div class="d-flex mb-2">
              <div>Payment Fee</div>
              <div class="ml-auto fw-500">
                {{ getPrice(parseFloat(item.paymentFee)) }}
              </div>
            </div>
            <div class="d-flex mb-2">
              <div>Payment Fee Currency</div>
              <div class="ml-auto fw-500">{{ item.paymentFeeCcy }}</div>
            </div>
            <div class="d-flex mb-2">
              <div>Payee Account Name</div>
              <div class="ml-auto fw-500">{{ item.payeeAccountName }}</div>
            </div>
            <div class="d-flex mb-2">
              <div>Payee Currency</div>
              <div class="ml-auto fw-500">{{ item.payeeCurrency }}</div>
            </div>
            <div class="d-flex mb-2">
              <div>Partner Account Number</div>
              <div class="ml-auto fw-500">{{ item.partnerBank.cardNo }}</div>
            </div>
            <div class="d-flex mb-2">
              <div>Payment Type</div>
              <div class="ml-auto fw-500">{{ getType(item.fixedModel) }}</div>
            </div>
            <div class="d-flex mb-2">
              <div>Purpose of Payment</div>
              <div class="ml-auto fw-500">
                {{ getPurpose(item.paymentPurpose) }}
              </div>
            </div>
            <div class="d-flex mb-2">
              <div>Payment Reference</div>
              <div class="ml-auto fw-500">{{ item.paymentReference }}</div>
            </div>
            <div class="d-flex mb-2">
              <div>Bank charges to be borne</div>
              <div class="ml-auto fw-500">{{ item.costBorne }}</div>
            </div>
            <div class="d-flex mb-2">
              <div>Proof of Payment</div>
              <div class="ml-auto fw-700">
                <a
                  class="link fz-14 fw-700 text-primary"
                  :href="item.MaterialFile"
                  >Download Voucher</a
                >
              </div>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
    <div v-else class="text-center p-4 fz-20 text-grey7 fw-500">
      {{ $t("No history found") }}
    </div>

    <div v-if="isLoading" class="dot-loading mt-3">
      <ul class="loader-circle">
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>
  </div>
</template>

<script>
import Account from "@/services/Account";
import CreateAccount from "@/services/CreateAccount";
import Withdrawal from "@/services/Withdrawal";
import Global from "@/services/Global";
import moment from "moment";

const STATUS = {
  1: "Pending",
  2: "Processing",
  3: "Approved",
  4: "Rejected",
  5: "Pending Document",
};

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL !== "/" ? process.env.BASE_URL : "",
      isLoading: false,
      currentPage: 1,
      perPage: 10,
      data: [],
      payeeList: [],
      payerName: "",
      fixedModelList: {
        1: "Foreign Exchange Account",
        2: "Receiving Account",
      },
      paymentPurposeOpt: {
        1: "current settlement",
        2: "loan",
        3: "travel expenses",
        4: "living expenses",
        5: "investment funds",
        6: "office expenses",
        7: "engineering funds",
        8: "labor costs/salaries",
        9: "tuition fees",
        10: "others",
      },
      search: "",
    };
  },
  methods: {
    viewDetails(param) {
      const parameter = {
        title: "Proof of Remittance Details",
        "sub-title": "",
        "desc-title": "",
        desc: "A remittance request has been approved from your RCPAY Virtual Banking account.",
        "table-title": "",
        params: JSON.stringify({
          "Payment Order Number": param["orderId"],
          "Payee Account Name": param["payeeAccountName"],
          "Bank Account Number": param["payeeUserNo"],
          Currency: param["payerCcy"],
          "Payment Amount": this.getAmount(parseFloat(param["payerAmt"])),
          "Payment Success Date": moment(param["paymentSuccessDate"]).format(
            "DD/MM/YYYY"
          ),
          "Request Status":
            param["status"].charAt(0).toUpperCase() + param["status"].slice(1),
        }),
      };

      const queryString = new URLSearchParams(parameter).toString();
      const url = `/document.html?${queryString}`;

      window.open(url, "_blank");
    },
    getPurpose(type) {
      return this.paymentPurposeOpt[parseInt(type)];
    },
    getAmount(amount) {
      return Global.addCommas(amount);
    },
    getType(type) {
      return this.fixedModelList[parseInt(type)];
    },
    goToRemittanceSuportingDoc(id) {
      this.$router.push({
        path: "/withdrawal-supporting-document",
        query: { id: id },
      });
    },
    goToResubmit(id) {
      localStorage.removeItem("update_remittance");
      localStorage.removeItem("update_partner");
      localStorage.removeItem("update_bank_info");

      DB.delete("paymentMaterial_filetype").then((data) => {
        self.filetypePaymentMaterial = filetype;
      });
      DB.delete("paymentMaterial").then((data) => {
        self
          .$swal({
            icon: "success",
            title: self.getMessage("Success"),
            showConfirmButton: true,
          })
          .then((result) => {
            self.$router.push({
              path: "/withdrawal",
            });
          });
      });

      this.$router.push({
        path: "/resubmit-remittance",
        query: { id: id },
      });
    },
    getPrice(amount) {
      return Global.addCommas(amount);
    },
    benificiaryList(user_no) {
      let self = this;
      var opt = {
        sort: "-id",
        userNo: user_no,
        page: this.currentPage,
        pagesize: this.perPage,
        sort: "-updated_at",
        expand: "benificiary",
      };

      Withdrawal.remittanceList(opt).then((response) => {
        if (response.status == 200) {
          let tmp = response.data;

          tmp.forEach(function (item, index) {
            self.data.push({
              id: item["id"],
              orderId: item["orderId"] ? item["orderId"] : "",
              payeeAccountName: item["partnerBank"]["partner"]["name"],
              payeeCurrency: item["partnerBank"]["accountCcy"],
              partnerBank: item["partnerBank"]["bankName"],
              payeeUserNo: item["partnerBank"].cardNo,
              fundType: "out",
              paymentCcy: item["paymentCcy"],
              paymentMode: item["paymentMode"],
              paymentFee: item["paymentFeeAmount"],
              paymentFeeCcy: item["paymentFeeCcy"],
              accountName: item["accountName"],
              costBorne: item["costBorne"],
              MaterialFile: item["paymentMaterialFile"].file,
              payerCcy: item["partnerBank"].accountCcy,
              fixedModel: item["fixedModel"],
              paymentPurpose: item["paymentPurpose"],
              paymentReference: item["paymentReference"],
              payerAmt:
                item["fixedModel"] == 1
                  ? item["paymentAmount"]
                  : item["payeeAmount"],
              paymentSuccessDate: item["paymentSuccessDate"]
                ? item["paymentSuccessDate"]
                : "",
              updated_at: item["updatedAt"],
              created_at: item["createdAt"],
              status: STATUS[item["status"]],
            });
          });
        }
      });
    },
    getData() {
      let self = this;
      CreateAccount.list({
        search: self.search,
        start: 0,
        length: -1,
      }).then((response) => {
        if (response.status == 200) {
          const data = response.data.data[0];
          self.payerName = data.information.name;
          self.benificiaryList(data.userNo);
        }
      });
    },
    doSearch() {},
    handleViewSubAccount(id, userType) {
      this.$router.push({
        path: "/list-sub-account",
        query: {
          account_id: id,
          user_type: userType,
        },
      });
    },
    handleSubAccount(data) {
      this.$emit("sub-account", data);
    },
    checkError(err) {
      const response = err.response;
      try {
        if (response.status == 401 && response.data.name == "Unauthorized") {
          localStorage.removeItem("token");
          localStorage.removeItem("member");
          localStorage.removeItem("isFirstTime");
          this.$router.push({
            path: "/login",
          });
        } else {
          if (localStorage.getItem("token")) {
            var msg = response.data ? response.data.message : err.message;
            this.$notify({
              type: "warn",
              text: msg,
            });
          }
        }
      } catch (e) {
        console.log(err);
      }
    },
  },
  mounted() {
    let self = this;
    this.$nextTick(() => {
      Account.listPayee().then((response) => {
        if (response.status == 200) {
          const data = response.data.data;
          data.forEach(function (item) {
            self.payeeList.push({
              id: item.relationship_userNo,
              text: item.accountName + " - " + item.relationship_userNo,
              accountName: item.accountName,
            });
          });
          self.getData();
        }
      });
    });
  },
  destroyed() {},
};
</script>

<style scoped>
.card-header {
  background-color: unset !important;
  border: unset !important;
}
.block-account {
  background: #f8f9fa;
  border-radius: 8px;
}
</style>
